/**
 * Baut Direktlinks von einer Artikelnummer (SKU) auf das jeweilige
 * Shop-Frontend - für die "in neuem Tab öffnen"-Links neben der
 * Artikelnummer in Lager-Übersicht und Lauf-Details.
 */

/**
 * Link zum B2C-Onlineshop (shop.molotow.com, WordPress/WooCommerce).
 *
 * Mit bekannter WooCommerce-Produkt-ID (`deId`) verlinkt der Redirect
 * `?p=<id>` direkt auf die Produktseite. Ohne `deId` (Artikel im B2C-Shop
 * nicht gefunden/verknüpft) fällt der Link auf eine Produktsuche nach der
 * Artikelnummer zurück.
 *
 * @param {string} sku
 * @param {number|string|null|undefined} deId
 * @return {string}
 */
export function b2cProductUrl(sku, deId) {
    const numericDeId = Number(deId);
    if (Number.isFinite(numericDeId) && numericDeId > 0) {
        return `https://shop.molotow.com/?p=${numericDeId}`;
    }

    return `https://shop.molotow.com/?s=${encodeURIComponent(sku)}&post_type=product`;
}

/**
 * Link zum B2B-Onlineshop (b2b.molotow.com, OpenMage). Es gibt dort keine
 * stabile, von hier aus bekannte Produkt-ID - eine Suche nach der
 * Artikelnummer reicht als Direktlink aus.
 *
 * @param {string} sku
 * @return {string}
 */
export function b2bProductUrl(sku) {
    return `https://b2b.molotow.com/catalogsearch/result/?q=${encodeURIComponent(sku)}`;
}

/**
 * Link zu Weclapp (molotow.weclapp.com). Mit bekannter Artikel-ID
 * (`weclappId`) verlinkt es direkt auf die Detailseite des Artikels
 * (`/app/article/<id>`, gegen den Live-Mandanten verifiziert am 09.08.2026).
 * Ohne ID bleibt nur die Artikelliste: Die alten `webapp/view/...`-Adressen
 * leiten seit der Oberflächen-Umstellung von Weclapp aufs Dashboard um, und
 * die neue Liste nimmt keinen Suchbegriff aus der Adresse an (searchTerm/q
 * beide getestet, beide wirkungslos). Die Nummer muss dort also von Hand ins
 * Suchfeld - dafür landet man wenigstens in der richtigen Ansicht.
 *
 * @param {string} sku
 * @param {number|string|null|undefined} weclappId
 * @return {string}
 */
export function weclappArticleUrl(sku, weclappId) {
    const numericId = Number(weclappId);
    if (Number.isFinite(numericId) && numericId > 0) {
        return `https://molotow.weclapp.com/app/article/${numericId}`;
    }

    return "https://molotow.weclapp.com/app/article";
}
